// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeUploadInitBody = {
  purpose: "avatar" | "poolBanner" | "chatPhoto" | "chatPdf";
  contentType:
    | "image/jpeg"
    | "image/png"
    | "image/webp"
    | "image/heic"
    | "application/pdf";
  byteSize: number;
  fileName?: string | null;
};

export type typeUploadInitOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    mediaId: string;
    uploadUrl: string;
    uploadMethod: "PUT";
    uploadHeaders: { contentType: string };
    expiresAt: string;
  };
};

export type typeUploadInitOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUploadInitOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUploadInitOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaUploadInitBody = {
  type: "object",
  properties: {
    purpose: {
      type: "string",
      enum: ["avatar", "poolBanner", "chatPhoto", "chatPdf"],
    },
    contentType: {
      type: "string",
      enum: [
        "image/jpeg",
        "image/png",
        "image/webp",
        "image/heic",
        "application/pdf",
      ],
    },
    byteSize: { type: "integer" },
    fileName: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
  },
  required: ["purpose", "contentType", "byteSize"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createUploadInit(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaUploadInitBody);
  }

  return async function postUploadInit(
    payload: typeUploadInitBody,
  ): Promise<typeUploadInitOutput200 | typeUploadInitOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postUploadInit" failed before calling the network. #5e1ea66a17a0`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#5e1ea66a17a0" },
        },
        data: null,
      } as typeUploadInitOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/upload/init`,
      httpMethod: "POST",
      options,
    })) as typeUploadInitOutput200 | typeUploadInitOutput400;
  };
}
